import { useFormik } from "formik";
import * as Yup from "yup";
import { toast } from "react-toastify";
import { useForgetPasswordMutation } from "../store/query/auth";
import { useNavigate } from "react-router-dom";

const useForgetPassword = () => {
  const [forgetPassword, { isLoading }] = useForgetPasswordMutation();
  const navigate = useNavigate();

  const handleSubmit = async (values) => {
    const res = await forgetPassword(values);
    //console.log("forget-password", res);
    if (res?.data?.status) {
      toast.success(res?.data?.message);
      navigate("/login");
    } else {
      toast.error(res?.data?.message);
    }
  };

  const formik = useFormik({
    initialValues: {
      email: "",
    },
    validateOnMount: true,
    validationSchema: Yup.object({
      email: Yup.string()
        .email("Provide vaild email address")
        .required("Required"),
    }),
    onSubmit: (values) => {
      handleSubmit(values);
    },
  });

  return { ...formik, isLoading };
};

export default useForgetPassword;
